import React from "react";
import styled from "styled-components";
import { borders } from "@sonder/ui/source/styled/theme";

const TaskPropertyWrapper = styled.div`
  border-bottom: ${borders.standard};
  display: inline-flex;
  flex-direction: row;
  line-height: 1.3;
  padding: 0.75rem 0;
`;
const TaskPropertyLabel = styled.div`
  display: inline-block;
  flex-shrink: 0;
  width: 10rem;
`;
const TaskPropertyValue = styled.div`
  display: inline-block;
  width: 100%;
`;

interface TaskPropertyProps {
  label: React.ReactNode;
  value: React.ReactNode;
}
export const TaskProperty = ({ label, value }: TaskPropertyProps) => (
  <TaskPropertyWrapper>
    <TaskPropertyLabel>{label}</TaskPropertyLabel>
    <TaskPropertyValue>{value}</TaskPropertyValue>
  </TaskPropertyWrapper>
);
